import { render, staticRenderFns } from "./VRButton.vue?vue&type=template&id=0a339b02&scoped=true"
import script from "./VRButton.vue?vue&type=script&lang=js"
export * from "./VRButton.vue?vue&type=script&lang=js"
import style0 from "./VRButton.vue?vue&type=style&index=0&id=0a339b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a339b02",
  null
  
)

export default component.exports